var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.type == 'service'
      ? ("flex cursor-pointer items-center bottom-area-text active_" + _vm.type + " res-class")
      : 'flex cursor-pointer items-center bottom-area-text res-class',on:{"click":function($event){return _vm.changeArea(_vm.type)}}},[_c('div',{class:(_vm.type + "-area-circle")}),_c('span',{class:("active_" + _vm.type)},[_vm._v(" "+_vm._s(_vm.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }